// extracted by mini-css-extract-plugin
export default {"container":"clients-filter_container__DRph-"};